// =============================================================================
// GENERATED by scripts/build-shared.cjs from functions/src/shared/jobBuilderIntent.js
// DO NOT EDIT — edit the canonical file and re-run `node scripts/build-shared.cjs`.
// (TASK-9163: ONE "job or question?" rule for the Smart Job Builder, client + server.)
//
// Imported ONLY by public/src/views/dispatch.js. The body below is the
// canonical file's PORTABLE CORE, copied byte for byte.
// =============================================================================

// The pre-TASK-9163 client DOT pre-check, moved here unchanged.
const JOB_BUILDER_DOT_STEM = /^(what|how|does|do i|is it|is there|when|why|explain|tell me|can i|should i|must i|are there|who|which)/i;
const JOB_BUILDER_DOT_KEYWORDS = /\b(dot|fmcsa|cfr|cdl|endorsement|med card|medical card|hours of service|hos|dvir|drug test|clearinghouse|dq file|permit|overweight|hazmat|placard|regulation|compliance|inspection|audit|violation|exemption|waiver)\b/i;

// Question shape: an interrogative / look-it-up opener, or a '?' anywhere.
const JOB_BUILDER_QUESTION_STEM = /^(do|does|did|have|has|is|are|was|were|where|what|whats|which|who|whose|when|how|any|anything|can you (find|show|tell|look|pull)|could you (find|show|tell|look|pull)|show me|find|look up|lookup|pull up|list|search|tell me)\b/i;

// Something only the company's records can answer.
const JOB_BUILDER_LOOKUP_SIGNAL = /\b(waypoints?|saved (locations?|places?|spots?|sites?)|coordinates|coords|gps|pins?|address(es)?|directions|history|records?|last (time|week|month|year|trip|load|run)|ago|previously|ever|did we|did you|have we|have you|do you have|do we have|how many|how much|how often|charged?|charging|billed?|billing|invoiced?|invoices?|paid|pay|rates?|price|pricing|cost|totals?|revenue|tickets?|mileage|po number|phone( number)?|contact (info|number))\b/i;

// A request to put work on the board.
const JOB_BUILDER_BUILD_VERB = /\b(build|create|make|set up|setup|add|schedule|book|start)\b[^.?!]{0,25}\b(jobs?|loads?|runs?|tickets?)\b/i;
const JOB_BUILDER_BUILD_REQUEST = /\b(need|needs|needed|send|dispatch|get|want|require|requires|put)\b[^.?!]{0,40}\b(trucks?|drivers?|crews?|hotshots?|trailers?|lowboys?|someone|somebody|anyone|anybody|guys?|rigs?|units?|haulers?|one)\b/i;
// "can you haul a load to…", "could someone run to Minot…".
const JOB_BUILDER_ASK_TO_DO = /\b(can|could|will|would) (you|we|someone|somebody)( please)? (haul|deliver|move|run|take|bring|pick up|drop|send|get|dispatch|have)\b/i;
// An order: "Have Kyle run…", "Haul the mats…". "have we / have you" is a question, not an order.
const JOB_BUILDER_IMPERATIVE_START = /^(please )?(haul|deliver|move|run|take|bring|pick up|drop|send|dispatch|get|put|assign|schedule|book|need|have (?!(we|you|they|i|any|anyone|anybody|ever)\b)\w+)\b/i;
// A future time or a day/date is SOFT evidence of a job being planned: it stops
// the regex from refusing the text, but it does not overrule the model's own
// "question" ("what is the address for tomorrow?" stays a question — COD).
const JOB_BUILDER_FUTURE = /\b(tomorrow|tonight|asap|first thing|next week|this (morning|afternoon|evening|week)|mon|monday|tue|tues|tuesday|wed|wednesday|thu|thur|thurs|thursday|fri|friday|sat|saturday|sun|sunday|\d{1,2}(:\d{2})? ?(am|pm)|\d{1,2}\/\d{1,2}(\/\d{2,4})?)\b/i;
// "if so, build me a job there" — the condition must lead to a build verb;
// "if so, what is its address?" is still a question (COD Code Reviewer).
const JOB_BUILDER_CONDITIONAL_BUILD = /\bif (so|yes|we do|you do|there is|not)\b[^.?!]{0,40}\b(build|create|make|schedule|book|set up|add|send|dispatch|put|haul|run)\b|\b(then|and) (build|create|make|schedule|book|set up)\b/i;
// History, not a request: the build verb itself is in the past — "did we send a
// truck…", "have we hauled…". Scoped to the verb (COD): "send a truck to the same
// address as last week" is still a request.
const JOB_BUILDER_PAST_REQUEST = /\b(did|have|has|had) (we|you|they|i)( ever| already)? (send|sent|need|needed|get|got|dispatch|dispatched|want|wanted|put|build|built|create|created|make|made|schedule|scheduled|book|booked|add|added|start|started|haul|hauled|run|ran|deliver|delivered|move|moved)\b/i;

function _jobBuilderNormalize(description) {
  // Curly apostrophes from phones read as the ASCII one; "what's" → "whats".
  return String(description == null ? '' : description).trim().replace(/[‘’]/g, '\'').replace(/'/g, '');
}

// HARD evidence of a build request. Judged per clause, so a past-tense clause
// only vetoes itself: "Did we send a truck to Tioga last week? Send a truck
// there tomorrow." is a request (COD round 2).
function jobBuilderIsBuildRequest(description) {
  const t = _jobBuilderNormalize(description);
  if (!t) return false;
  if (JOB_BUILDER_CONDITIONAL_BUILD.test(t)) return true;
  const clauses = t.split(/[.?!;]+/);
  for (let i = 0; i < clauses.length; i++) {
    const c = clauses[i].trim();
    if (!c || JOB_BUILDER_PAST_REQUEST.test(c)) continue;
    if (JOB_BUILDER_BUILD_VERB.test(c) || JOB_BUILDER_BUILD_REQUEST.test(c)
      || JOB_BUILDER_ASK_TO_DO.test(c) || JOB_BUILDER_IMPERATIVE_START.test(c)) return true;
  }
  return false;
}

function _jobBuilderHasFutureTime(description) {
  return JOB_BUILDER_FUTURE.test(_jobBuilderNormalize(description));
}

function jobBuilderIsQuestionShaped(description) {
  const t = _jobBuilderNormalize(description);
  if (!t) return false;
  return JOB_BUILDER_QUESTION_STEM.test(t) || t.indexOf('?') >= 0;
}

// → { kind: 'dot' | 'lookup' | null, buildRequest: boolean }
function classifyJobBuilderInput(description) {
  const raw = String(description == null ? '' : description).trim();
  const buildRequest = jobBuilderIsBuildRequest(raw);
  if (!raw) return { kind: null, buildRequest: false };
  // Rule 1 — byte-for-byte the old client pre-check (it tested the raw text).
  if (JOB_BUILDER_DOT_STEM.test(raw) && JOB_BUILDER_DOT_KEYWORDS.test(raw)) {
    return { kind: 'dot', buildRequest: buildRequest };
  }
  // Rules 2 + 3.
  const t = _jobBuilderNormalize(raw);
  const lookupSignal = JOB_BUILDER_LOOKUP_SIGNAL.test(t) || /^where\b/i.test(t);
  if (!buildRequest && !_jobBuilderHasFutureTime(t) && jobBuilderIsQuestionShaped(t) && lookupSignal) {
    return { kind: 'lookup', buildRequest: false };
  }
  return { kind: null, buildRequest: buildRequest };
}

// → 'question' | 'job'. `modelIntent` is whatever the model put in the
// response's `intent` field (may be missing, garbled or any case).
function resolveJobParseIntent(modelIntent, description) {
  const c = classifyJobBuilderInput(description);
  if (c.kind) return 'question';
  if (c.buildRequest) return 'job';
  const m = String(modelIntent == null ? '' : modelIntent).trim().toLowerCase();
  // Rule 4 — the model may flag a question only when the text reads like one.
  if (m === 'question' && jobBuilderIsQuestionShaped(description)) return 'question';
  return 'job';
}

export { classifyJobBuilderInput, resolveJobParseIntent, jobBuilderIsBuildRequest, jobBuilderIsQuestionShaped };
